<template>
  <div>
    <side-bar title="Select channels" icon="movie" search v-model="search">

      <template #buttons>
        <k-btn icon icon-name="restart_alt" no-margin size="xs" v-tooltip.bottom="'Reset layout'" @click="reset_layout"></k-btn>
      </template>

      <k-list bordered :items="filtered_channels" @click="toggleChannelFilter" two-line>
        <template #left="{ item }">
          <k-icon small v-if="is_running(item)" color="success">circle</k-icon>
          <k-icon small v-else color="primary">circle</k-icon>
        </template>
        <template #default="{ item }">
          <div :class="{'monitor-disabled': !is_running(item)}">
            <channel-title grid :channel="item.channel" :alternative="item.alternative"></channel-title>                  
          </div>
        </template>
        <template #subtitle="{ item }">
          <div :class="{'monitor-disabled': !is_running(item)}" style="text-transform: capitalize;">{{item.state}}</div>
        </template>
        <template #right="{ item }">
          <k-btn no-margin icon>
            <k-icon small v-if="is_visible(item)" color="accent">visibility</k-icon>
            <k-icon small v-if="!is_visible(item)">visibility_off</k-icon>
          </k-btn>
        </template>
      </k-list>
    </side-bar>
  </div>
</template>
<script>
  import ChannelModel from '@/models/channel.js';
  import InstanceModel from '@/models/instance.js';
  import naturalSort from 'natural-sort'
  import SideBar from '@/components/SideBar';
  import ChannelTitle from '@/components/ChannelTitle.vue';



  export default {
    props: ['monitorType'],
    components: {
      SideBar,
      ChannelTitle
    },
    data () {
      return {
        naturalSort: naturalSort(),
        search: "",
        ready: false,
      }
    },
    computed: {
      instances() {
        return this.$store.state.instances;
      },
      system_channels () {
        return _.filter(this.channels, (channel) => { return _.get(channel, "channel.meta.system_channel", false); }).sort((a,b) => {
          var aTitle = _.get(a, "channel.title", "");
          var bTitle = _.get(b, "channel.title", "");
          return this.naturalSort(aTitle, bTitle);
        });
      },
      default_channels () {
        return _.filter(this.channels, (channel) => { 
          var instance = ChannelModel.instance(channel.channel, null);
          if (_.get(instance, "meta.is_developer", false) == true) return false;
          return !_.get(channel, "channel.meta.system_channel", false); 
        }).sort((a,b) => {
          var aTitle = _.get(a, "channel.title", "");
          var bTitle = _.get(b, "channel.title", "");
          return this.is_running(b) - this.is_running(a) || this.naturalSort(aTitle, bTitle);
        })
      },
      filtered_channels() {
        var channels = [];
        if(!this.monitorType) channels = this.default_channels;
        if(this.monitorType == "system") channels = this.system_channels;

        if(this.search.length < 3) return channels;
        return _.filter(channels, (channel) => {
          return _.get(channel, "channel.title", "").toLowerCase().includes(this.search.toLowerCase());
        });
      },
      channels () {
        var st = ChannelModel.status_all();
        if (typeof(st) != "undefined") {
          var res = [];
          _.each(st, (data, id) => {
            var headend = this.instances[data.headend_instance];
            var state = (this.get_source_state(data)||{}).state;
            if (typeof(headend) != "undefined") {
              var uuid = id.split(":")[0];
              var alternative = id.split(":")[1] || "";
              var channel = ChannelModel.channel_by_uuid(uuid);
              if(channel) res.push({key: id, state: state, channel: channel, alternative: alternative});
            }
          });
          return res;
        }
        return [];
      },
      monitor_filters () {
        return this.$store.state.account.meta.monitor_channel_filter ||[];
      }
    },
    methods: {
      reset_layout() {
        var key = this.monitorType == "system" ? "monitor-system" : "monitor";
        localStorage.removeItem("kvideogrid:" + (this.$store.state.account.id || "") + ":" + key);
        window.location.reload();
      },
      toggleChannelFilter(channel) {
        var acc = _.cloneDeep(this.$store.state.account);
        acc.meta.monitor_channel_filter = _.xor(acc.meta.monitor_channel_filter, [channel.key]);
        this.$store.dispatch("update_profile", acc);
      },
      is_running(channel) {
        return channel.state == "connected";
      },
      is_visible(channel) {
        return typeof(_.find(this.monitor_filters, (uuid) => { return uuid == channel.key; })) != "undefined";
      },
      get_state(data, type) {
        var i = data.instance;
        if (typeof(i) != "undefined") {
          var s = i[type];
          if (typeof(s) != "undefined") {
            return s;
          }
        }
        return;
      },

      get_source_state(data) {
        return this.get_state(data, "source");
      }
    },
    mounted() {
      this.$store.dispatch("get_profile").then(() => {
        this.ready = true;
      }, () => {});
    }
  }
</script>
<style scoped>
  .monitor-disabled {
/*    color: var(--ks-col-secondary) !important;*/
  }
</style>